/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable camelcase */
import { Checkbox } from "@mui/material";

export const GOHONZON_APPLY_TABLE_COL = [
  {
    displayName: "ELIGIBLE",
    key: "eligible",
  },
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  {
    displayName: "BLOCK",
    key: "block",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const GOHONZON_APPLICATIONS_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  {
    displayName: "DISTRICT",
    key: "district",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const GOHONZON_SEARCH_COL = [
  "createdAt",
  "updatedAt",
  "createdBy",
  "updatedBy",
  "memberId",
  "gender",
  "type",
  "fullName",
  "emailId",
  "mobileNumber",
  "addressLine1",
  "addressLine2",
  "city",
  "pincode",
  "state",
  "parentsEmailId",
  "parentsMobileNumber",
  "nationalityId",
  "divisionId",
  "divisionName",
  "subdivisionId",
  "subDivisionName",
  "introducedBy",
  "areaId",
  "areaName",
  "zoneId",
  "zoneName",
  "regionId",
  "regionName",
  "chapterId",
  "chapterName",
  "districtId",
  "districtName",
  "blockId",
  "blockName",
  "introducerName",
  "introducerEmail",
  "introducerMobileNumber",
  "dob",
  "introductionId",
  "profession",
  "present",
];

export const GOHONZON_APPLICATION_VERIFICATION_COL = [
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "DISTRICT",
    key: "District",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "SUBMITTED BY ",
    key: "submittedyBy",
  },
  {
    displayName: "STATUS",
    key: "STATUS",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_INTERVIEW_COL = [
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "CHAPTER",
    key: "Chapter",
  },
  {
    displayName: "DISTRICT",
    key: "District",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "SUBMITTED BY ",
    key: "submittedBy",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_VERIFICATION_COL = [
  {
    displayName: Checkbox,
    key: "checkBox",
  },
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "CHAPTER",
    key: "Chapter",
  },
  {
    displayName: "DISTRICT",
    key: "District",
  },
  {
    displayName: "APPLIED BY ",
    key: "appliedBy",
  },
  {
    displayName: "STATUS",
    key: "status",
  },
];

export const GOHOZON_BATCH_ALLOTMENT_COL = [
  {
    displayName: "BATCH ID",
    key: ["BATCH ID"],
  },
  {
    displayName: "NO OF APPLICATIONS",
    key: ["phone", "email"],
  },
  {
    displayName: "ORGANISATIONAL STRUCTURE",
    key: "ORGANISATIONAL_STRUCTURE",
  },
  {
    displayName: "BATCH CREATED BY",
    key: "BATCH",
  },
  {
    displayName: "STATUS",
    key: "STATUS",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHOZON_BATCH_HISTORY_COL = [
  {
    displayName: "BATCH ID",
    key: ["BATCH ID"],
  },
  {
    displayName: "NO OF APPLICATIONS",
    key: ["phone", "email"],
  },
  {
    displayName: "ORGANISATIONAL STRUCTURE",
    key: "ORGANISATIONAL_STRUCTURE",
  },
  {
    displayName: "BATCH CREATED BY",
    key: "BATCH",
  },
  {
    displayName: "STATUS",
    key: "STATUS",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_ALLOTMENT_COL = [
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "REGION",
    key: "Region",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_BATCH_VIEW_COL = [
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "REGION",
    key: "Region",
  },
  {
    displayName: "STATUS",
    key: "status",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
];

export const GOHOZON_HANDOVER_COL = [
  {
    displayName: "BATCH ID",
    key: ["batchId"],
  },
  {
    displayName: "NO OF APPLICATIONS",
    key: ["NoOfApplications"],
  },
  {
    displayName: "NO OF GOHONZON ALLOTED",
    key: "NoOfGohonzonAlloted",
  },
  {
    displayName: "ORGANISATIONAL STRUCTURE",
    key: "organisationalStructure",
  },
  {
    displayName: "Action ",
    key: "Action",
  },
];

export const GOHONZON_BATCH_CONFERRAL_COL = [
  {
    displayName: "BATCH ID",
    key: ["batchId"],
  },
  {
    displayName: "NO OF APPLICATIONS",
    key: ["NoOfApplications"],
  },
  {
    displayName: "HANDED OVER TO",
    key: "handoverToMember",
  },
  // {
  //   displayName: "ORGANISATIONAL STRUCTURE",
  //   key: "organisationalStructure",
  // },
  // {
  //   displayName: "GOHONZON TYPE",
  //   key: "gohonzonType",
  // },
  // {
  //   displayName: "CONFERRAL DATE",
  //   key: "CONFERRAL",
  // },
  // {
  //   displayName: "BATCH CONFERRAL",
  //   key: "BATCH_CONFERRAL",
  // },
  {
    displayName: "VIEW",
    key: "view",
  },
];

export const GOHONZON_CONFERRAL_COL = [
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "VERIFIED BY ",
    key: "verifiedBy",
  },
  {
    displayName: "STATUS",
    key: "STATUS",
  },
  {
    displayName: "CONFERRED DATE",
    key: "CONFERRED",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_CANCEL_REQ_COL = [
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "REGION",
    key: "Region",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "REQUESTED BY",
    key: "requestedBy",
  },
  {
    displayName: "BATCH ID",
    key: ["batchId"],
  },
  // {
  //   displayName: "STATUS",
  //   key: "STATUS",
  // },
  // {
  //   displayName: "GOHONZON",
  //   key: "GOHONZON",
  // },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_RETURN_REQ_COL = [
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "REGION",
    key: "Region",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];
export const GOHONZON_RETURN_VERIFICATION_COL = [
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "DISTRICT",
    key: "District",
  },
  {
    displayName: "GOHONZON TYPE ",
    key: "gohonzonType",
  },
  {
    displayName: "STATUS",
    key: "status",
  },
  {
    displayName: "APPLIED BY",
    key: "submittedBy",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const RETURNED_GOHONZON_HANDOVER_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  {
    displayName: "REGION",
    key: "Region",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "SUBMITTED BY ",
    key: "submittedyBy",
  },
  {
    displayName: "STATUS",
    key: "STATUS",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_OMAMORI_ALLOTMENT_COL = [
  {
    displayName: "MEMBER ID",
    key: "memberID",
  },
  {
    displayName: "MEMBER NAME",
    key: "memberName",
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "REGION",
    key: "Region",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_OMAMORI_HANDOVER_COL = [
  {
    displayName: "MEMBER ID",
    key: "memberID",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["contactInfo"],
  },
  {
    displayName: "ORGANISATIONAL STRUCTURE",
    key: "organisationalStructure",
  },
  {
    displayName: "ALLOTED BY ",
    key: "allotedBy",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_APPROVAL_COL = [
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "REGION",
    key: "Region",
  },
  // {
  //   displayName: "GOHONZON TYPE",
  //   key: "gohonzonType",
  // },
  {
    displayName: "SUBMITTED BY ",
    key: "submittedBy",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_OMAMORI_CONFERRAL_COL = [
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "VERIFIED BY ",
    key: "verifiedBy",
  },
  {
    displayName: "STATUS",
    key: "STATUS",
  },
  {
    displayName: "CONFERRED DATE",
    key: "CONFERRED",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_REPLACEMENT_CONFERRAL_COL = [
  {
    displayName: "MEMBER ID",
    key: ["memberID"],
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName"],
  },
  {
    displayName: "CONTACT INFO",
    key: "contactInfo",
  },
  {
    displayName: "DIVISION",
    key: "Division",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "VERIFIED BY ",
    key: "verifiedBy",
  },
  {
    displayName: "STATUS",
    key: "STATUS",
  },
  {
    displayName: "CONFERRED DATE",
    key: "CONFERRED",
  },
  {
    displayName: "ACTION",
    key: "ACTION",
  },
];

export const GOHONZON_HANDOVER_INVENTORY_COL = [
  {
    displayName: "DATE",
    key: "date",
  },
  {
    displayName: "GOHONZON",
    key: "gohonzon",
  },
  {
    displayName: "TRANSACTION TYPE",
    key: "contactInfo",
  },
  {
    displayName: "BATCH NO",
    key: "batch",
  },
  {
    displayName: "HANDOVER OVER TO",
    key: "Division",
  },
  {
    displayName: "ORGANISATIONAL STRUCTURE",
    key: "gohonzonType",
  },
  {
    displayName: "STATUS",
    key: "verifiedBy",
  },
];

export const GOHONZON_MASTER_INVENTORY_COL = [
  {
    displayName: "DATE",
    key: "date",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzon",
  },
  {
    displayName: "QUANTITY",
    key: "contactInfo",
  },
  {
    displayName: "RECIEVED BY",
    key: "batch",
  },
];

export const MASTER_INVENTORY_COL = [
  {
    displayName: "DATE",
    key: "date",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzonType",
  },
  {
    displayName: "QUANTITY",
    key: "quantity",
  },
];

export const RECENT_GOHONZON_COL = [
  {
    displayName: "DATE",
    key: "date",
  },
  {
    displayName: "GOHONZON",
    key: "gohonzon",
  },
  {
    displayName: "ENTRY TYPE",
    key: "entryType",
  },
  {
    displayName: "HANDOVER OVER TO",
    key: "handoverByRegionSi",
  },
  {
    displayName: "ORG. STRUCTURE",
    key: "orgStructure",
  },
];

export const GOHONZON_TRACKING_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  {
    displayName: "ORGANIZATIONAL STRUCTURE",
    key: "organizationalStructure",
  },
  {
    displayName: "GOHONZON TYPE",
    key: "gohonzon",
  },
  {
    displayName: "STATUS",
    key: "status",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];
